var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/spotArea.a089c383.png","uri@2x": __webpack_public_path__ + "static/media/spotArea.9ee90d9c.png","uri@3x": __webpack_public_path__ + "static/media/spotArea.72da0f20.png",
    width: 40,
    height: 40
});